var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"pageSize"},[_c('Head',{attrs:{"bgColor":"#5aaca9","bgColorRight":"#5aaca9"}}),_c('div',{staticClass:"way_content"},[_c('div',{staticClass:"mechanism"},[_c('img',{staticClass:"wh100",attrs:{"src":_vm.showData.sickPicture}})])])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }